import { captureInvitationLinkCopied } from "@src/utils/analytics";
import { useCallback, useEffect, useState } from "react";

const COPY_RESET_DELAY_MS = 2000;

export function useCopyInvitationLink(invitationLink: string | null) {
	const [isLinkCopied, setIsLinkCopied] = useState(false);

	const handleCopyLink = useCallback(() => {
		if (!invitationLink) {
			return;
		}

		void navigator.clipboard.writeText(invitationLink);
		captureInvitationLinkCopied();
		setIsLinkCopied(true);
	}, [invitationLink]);

	useEffect(() => {
		if (!isLinkCopied) {
			return;
		}

		const timeoutId = window.setTimeout(() => {
			setIsLinkCopied(false);
		}, COPY_RESET_DELAY_MS);

		return () => {
			window.clearTimeout(timeoutId);
		};
	}, [isLinkCopied]);

	return {
		isLinkCopied,
		handleCopyLink,
	};
}
